import { ContactPageTypes,  MetaTagsProps} from "@/types";
import {BUSINESS_NAME, OG_PATH, WEBSITE_URL} from "@/content";

export const metaTagsContact : MetaTagsProps = {
    title: `Contact Us - ${BUSINESS_NAME}`,
    description: `Contact ${BUSINESS_NAME} - Level 2 Certified Electricians in Sydney.`,
    keywords: "Proelec Group, level 2 electrician sydney, electrical services sydney, residential electrician sydney, commercial electrician sydney, data cabling sydney, switchboard upgrades sydney, lighting installations sydney, electrical repairs sydney, licensed electricians sydney, contact proelec group",
    url: `${WEBSITE_URL}/contact`,
    ogImage: `${OG_PATH}img1.jpg`,
    type: "website",
}

export const contactPageContent : ContactPageTypes = {
    title: 'Contact Us',
    description: 'Learn more about our company, our mission, and the team behind our success.',
    images: [],
}
